import classes from "../classes";
import FormError from "./form-error";
import { Link } from "react-router-dom";
import { Map } from "immutable";
import React from "react";

export default class PasswordResetConfirmationForm extends React.PureComponent {

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit(e) {
    var { passwordResetConfirmation, token } = this.props;
    e.preventDefault();
    passwordResetConfirmation(this.refs.email.value, this.refs.newPassword.value, this.refs.verifyPassword.value, token);
  }

  render() {
    var { communications } = this.props;
    var loading = communications.getIn(["password-reset-confirmation", "state"]) === "in progress";
    var errors = communications.getIn(["password-reset-confirmation", "error"]) || Map();

    var invalidLinkMessage;
    if (errors.get("reset_password_token")) {
      invalidLinkMessage = (
        <div className="form_message form_message--has-error">
          The link you used to reset your password has expired or is invalid. Please
          {" "}

          <Link className="link--is-underlined" to="/password-reset">
            reset your password
          </Link>

          {" "}
          again.
        </div>
      );
    }

    return (
      <form className="form--is-horizontal" onSubmit={this.onSubmit}>
        <div className="batch-g batch-g--padding batch-g--valign-center">

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            {invalidLinkMessage}
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="email">
              Email Address
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" id="email" name="email" placeholder="Email Address" ref="email" type="email" />

            <FormError error={errors.get("email")} name="Email Address" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="new_password">
              New Password
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" id="new_password" name="new_password" placeholder="New Password" ref="newPassword" type="password" />

            <FormError error={errors.get("new_password")} name="New Password" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4">
            <label htmlFor="verify_password">
              Verify Password
            </label>
          </div>

          <div className="batch-c-1-1 batch-c-md-3-4">
            <input className="form_input" id="verify_password" name="verify_password" placeholder="Verify Password" ref="verifyPassword" type="password" />

            <FormError error={errors.get("verify_password")} name="Verify Password" />
          </div>

          <div className="batch-c-1-1 batch-c-md-1-4" />

          <div className="batch-c-1-1 batch-c-md-3-4">
            <div className="form_action">
              <input
                className={classes({
                  "btn": true,
                  "btn--primary": true,
                  "btn--is-loading": loading,
                })}
                disabled={loading}
                type="submit"
                value={loading ? "Processing" : "Reset Your Password"} />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
